const langMapping = {
  'zh-TW':
    'fxmt1588.com fxmt5566.com fxmt6600.com fxmt8800.com www.fxmt6600.com www.fxmt8800.com www.fxmt1588.com www.fxmt5566.com',
  en: 'fxmt534.com fxmt024.com',
  ar: 'fxmt336.com fxmt588.com',
  pt: 'fxmt6650.com fxmt6660.com'
}

export const getDefaultLang = () => {
  let lang = process.env.DEFAULT_LANGUAGE
  try {
    let domain = window.location.hostname
      .split('.')
      .splice(1)
      .join('.')
      .split(':')[0]
    for (let locale in langMapping) {
      let domainList = langMapping[locale].split(' ')
      if (domainList.includes(domain)) {
        lang = locale
      }
    }
    console.log('默认语言', lang, domain)
  } catch (e) {
    console.error(e, '设置默认语言时出错')
  }
  return lang
}



// WEBPACK FOOTER //
// ./src/utils/lang.js